import React from "react";
import { Paper, Box, Typography, Chip } from "@mui/material";

export default function StationSidebar({ 
  list, 
  loading, 
  currentFilter, 
  onNavigate,
  sx = {} 
}) {
  
  // Helper to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "long", day: "numeric", year: "numeric"
    });
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        background: "white",
        borderRadius: 2,
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        height: "fit-content",
        maxHeight: "600px", 
        overflowY: "auto",
        boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
        border: "1px solid #e5e5e5",
        ...sx
      }}
    >
      
      {/* HEADER WITH CHIP */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: "#123464", fontSize: "1.2rem" }}>
          STATION OPENINGS
        </Typography>
        {currentFilter !== "All" && (
          <Chip 
            label={`Filter: ${currentFilter}`} 
            size="small" 
            sx={{ 
                bgcolor: "#009fb6", 
                color: "white", 
                fontWeight: 600, 
                fontSize: "0.75rem" 
            }} 
          />
        )}
      </Box>

      {/* LIST ITEMS */}
      {list.length > 0 ? (
        list.map((item) => (
          <Box key={item.id} sx={{ mb: 2 }}>
            {item.isCurrent ? (
              <Box sx={{ 
                  display: 'block', 
                  cursor: 'default', 
                  backgroundColor: "#f0f8ff", 
                  borderLeft: "4px solid #00b5e2", 
                  borderRadius: 1, 
                  p: 2 
              }}>
                <Typography sx={{ fontWeight: 800, color: "#00b5e2", mb: 0.5, fontSize: "1.1rem" }}>
                  {formatDate(item.date_opened)}
                </Typography>
                <Typography sx={{ fontWeight: 800, color: "#0a1a3b", lineHeight: 1.2, fontSize: "1.2rem" }}>
                  {item.location}
                </Typography>
              </Box>
            ) : (
              // CLICKABLE ITEM (Uses the prop function)
              <Box 
                onClick={() => !loading && onNavigate(item)} 
                sx={{ 
                  cursor: loading ? 'wait' : 'pointer', 
                  display: 'block', 
                  pointerEvents: loading ? 'none' : 'auto', 
                  p: 2, 
                  borderRadius: 1, 
                  transition: 'all 0.2s ease', 
                  // "&:hover": { 
                  //     backgroundColor: loading ? 'transparent' : '#f8f8f8', 
                  //     transform: loading ? 'none' : 'translateX(4px)' 
                  // } 
                }}
              >
                <Typography sx={{ fontWeight: 800, color: "#00b5e2", mb: 0.5, fontSize: "1.1rem" }}>
                  {formatDate(item.date_opened)}
                </Typography>
                <Typography sx={{ fontWeight: 800, color: "#0a1a3b", lineHeight: 1.2, fontSize: "1.2rem", transition: "0.2s", cursor: "pointer", "&:hover": { color: "#00b5e2" } }}>
                  {item.location}
                  </Typography>

              </Box>
            )}
          </Box>
        ))
      ) : (
        <Typography color="text.secondary" fontSize="1rem">No station data available.</Typography>
      )}
    </Paper>
  );
}